<template>
  <ListRequest />
</template>

<script>
import ListRequest from "../components/request/ListRequest.vue";

export default {
  components: {
    ListRequest
  }
};
</script>
